<aside class="details-card" aria-labelledby="cxp-deliverable-details-title">
  <h2 id="cxp-deliverable-details-title" class="details-title">Details</h2>

  <section class="details-section" [dataSelector]="'cxp-deliverable-detail-client-access'">
    <h3 class="details-section-title">Client access</h3>
    @if (isLoading()) {
      <p class="details-loading" [dataSelector]="'cxp-deliverable-detail-client-access-loading'">Loading</p>
    } @else {
      @for (contact of clientContacts(); track contact.contactId) {
        <div class="details-row">
          <span class="details-avatar" aria-hidden="true">{{ initialsForContact(contact) }}</span>
          <div class="details-row-text">
            @if (contact.fullName) {
              <p class="details-name">{{ contact.fullName }}</p>
            }
            <p class="details-email" [title]="contact.email">{{ contact.email }}</p>
          </div>
        </div>
      } @empty {
        <p class="details-empty">No client recipients on file.</p>
      }
    }
  </section>

  <section class="details-section" [dataSelector]="'cxp-deliverable-detail-team'">
    <h3 class="details-section-title">Team</h3>
    @if (isLoading()) {
      <p class="details-loading" [dataSelector]="'cxp-deliverable-detail-team-loading'">Loading</p>
    } @else {
      @for (member of teamMembers(); track member.staffId) {
        <div class="details-row">
          <span class="details-avatar" aria-hidden="true">{{ initialsForTeamMember(member) }}</span>
          <div class="details-row-text">
            <p class="details-name">{{ member.fullName }}</p>
            <a class="details-email" [href]="'mailto:' + member.email" [title]="member.email">{{ member.email }}</a>
          </div>
        </div>
      } @empty {
        <p class="details-empty" [dataSelector]="'cxp-deliverable-detail-team-empty'">No team members available</p>
      }
    }
  </section>
</aside>
